import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      whiteSpace: 'nowrap',
    },
  },
  positiveAmount: {
    color: theme.palette.success.light,
  },
  negativeAmount: {
    color: theme.palette.error.light,
  },
  noColor: {
    color: 'inherit',
  },

  titleVariant: {
    paddingLeft: 0.5,
    fontWeight: 'bold',
    fontFamily: '"Bebas Neue"',
  },
}));
